import { Box } from '@mui/system'
import { FC } from 'react'
import { FamiliarFaceReviewWithoutAiOutdoorActivity, OutdoorEngagement, ProcessedActivity } from '../../../../../../api/models'
import { ActivityTimingResult } from '../useActivityTiming'
import { ActivityFieldBox } from '../ActivityFieldBox'
import { StartEndTimeBox } from '../StartEndTimeBox'
import { EqualColumnsGrid } from '../../EqualColumnsGrid'

interface FamiliarFaceReviewWithoutAiActivityProps {
  activity: Extract<ProcessedActivity, FamiliarFaceReviewWithoutAiOutdoorActivity>
  engagement: OutdoorEngagement
  timing: ActivityTimingResult
}

export const FamiliarFaceReviewWithoutAiActivity: FC<FamiliarFaceReviewWithoutAiActivityProps> = ({ activity, engagement, timing }) => {
  const facedMatched = Array.isArray(engagement.result?.matchedFamiliarFaces) ? engagement.result.matchedFamiliarFaces.length : 0

  return (
    <EqualColumnsGrid>
      <StartEndTimeBox
        startMs={timing.startOffsetMs}
        startSeconds={timing.startOffsetSeconds}
        endMs={timing.endOffsetMs}
        endSeconds={timing.endOffsetSeconds}
        isCompleted={!!activity.completed}
      />
      <ActivityFieldBox label="Face(s) Matched" labelTestId="activity-card-face-match">
        <Box data-testid="activity-card-face-match-count">{facedMatched}</Box>
      </ActivityFieldBox>
    </EqualColumnsGrid>
  )
}
